import * as api from "services/api";

export const GET_CASHIERS = "[CASHIER REPORT] GET_CASHIERS";
export const GET_CASHIERS_FAILED = "[CASHIER REPORT] GET_CASHIERS_FAILED";
export const GET_CASHIERS_SUCCESS = "[CASHIER REPORT] GET_CASHIERS_SUCCESS";

export const SET_VALUE = "[CASHIER REPORT] SET_VALUE";
export const CLEAR_VALUE = "[CASHIER REPORT] CLEAR_VALUE";

export function getCashiers() {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_CASHIERS
    });

    const { token } = getState().login;

    let response = await api.sendGet("/cashier", {
      Authorization: "Bearer " + token
    });

    if (response.ok) {
      let json = await response.json();

      dispatch({
        type: GET_CASHIERS_SUCCESS,
        payload: json.model
      });
    } else {
      dispatch({ type: GET_CASHIERS_FAILED });
    }
  };
}

export function getCashiersV2(
  skip,
  take,
  filter,
  sort,
  desc,
  toExport,
  callback
) {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_CASHIERS
    });

    const { login } = getState();
    const { token } = login;

    let response = await api.sendGet(
      `/cashier/v2?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter || ""}`,
      {
        Authorization: "Bearer " + token
      }
    );

    if (response.ok) {
      let result = await response.json();

      if (result.isValid) {
        if (toExport) {
          dispatch(setValue({ loading: false }));
        } else {
          dispatch({
            type: GET_CASHIERS_SUCCESS,
            payload: result.model
          });

          if (result.params)
            dispatch(
              setValue({
                pages: Math.ceil(result.params.count / take),
                ...result.params
              })
            );
        }

        callback && callback(null, result.model);
      } else {
        dispatch({ type: GET_CASHIERS_FAILED, payload: result.errors });
        callback && callback(result.errors, result.model);
      }
    } else {
      dispatch({ type: GET_CASHIERS_FAILED });
      callback && callback("Ocorreu um erro ao tentar carregar os caixas");
    }
  };
}

export function setValue(payload) {
  return {
    type: SET_VALUE,
    payload
  };
}

export function clearValue() {
  return {
    type: CLEAR_VALUE
  };
}
